import React, { Component } from 'react'
import { Row, Col, Table, InputNumber, Pagination, Checkbox, Button, Radio, Modal } from 'antd'
import _ from "underscore"
import PropTypes from "prop-types"
import { app } from "../../app"
import api from "../../api"
import utils from "../../utils"

const RadioGroup = Radio.Group
const RadioButton = Radio.Button

class ReportDration extends Component {
    constructor (props) {
        super(props)
        this.state = {
            selectedRowKeys: [],
            dataList: [],
            editList: [],
            record_modal: false,
            page: 1,
            total: 0,
            rpage: 1,
            rtotal: 0,
            recordList: [],
        }
    }

    async componentDidMount () {
        this._isMounted = true
        await this.handleDrationData()
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 服务时长记录列表
     * @param rpage
     * @returns {Promise<void>}
     */
    handleRecordData = async (rpage = 1) => {
        await this.setState({ rpage, record_loading: true })
        let { id } = this.props, params = {
            id,
            page: rpage,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { flag, data, msg, total } = await app.post(api.ReportsDurationRecordList, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        if (rpage === this.state.rpage) {
            await this.setData({
                record_loading: false,
                recordList: utils.addArrayKey(data),
                rtotal: parseInt(total || 0),
            })
        }
    }

    /**
     * 服务时长列表
     * @param page
     * @returns {Promise<void>}
     */
    handleDrationData = async (page = 1) => {
        await this.setState({ page, data_loading: true })
        let { id } = this.props, params = {
            id,
            page,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { flag, data, msg,duration_sum, total } = await app.post(api.ReportsDurationList, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        if (page === this.state.page) {
            await this.setData({
                selectedRowKeys: [],
                data_loading: false,
                duration_sum:duration_sum,
                dataList: utils.addArrayKey(data),
                total: parseInt(total || 0),
            })
        }
    }

    /**
     * 全选
     * @param e
     */
    handleAllSel = (e) => {
        let checked = e.target.checked
        let selectedRowKeys = []
        if (checked) {
            selectedRowKeys = _.range(1, this.state.dataList.length + 1)
        }
        this.setData({ selectedRowKeys })
    }

    /**
     * 设置编辑列表
     */
    handleSetEditList = (indexno, duration) => {
        const { editList } = this.state
        let index = editList.findIndex(e => e.indexno === indexno)
        if (index !== -1) {
            editList[index].duration = duration
        } else {
            editList.push({ indexno, duration })
        }
    }

    /**
     * 多个设置编辑列表
     */
    handleMultipleSetEditList = async (duration, keys) => {
        if (duration) {
            let { dataList } = this.state
            await this.setData({ dataList: [] })
            for (let i = 0; i < keys.length; i++) {
                let data = dataList[keys[i] - 1]
                data.duration = duration
                this.handleSetEditList(data.indexno, data.duration)
            }
            await this.setData({ dataList })
        }
    }

    /**
     * 确定
     */
    handleConfirm = async () => {
        let { editList } = this.state
        if (editList.length > 0) {
            await this.setData({ submit_loading: true })
            let { id, onClose } = this.props, params = {
                id,
                str: JSON.stringify(editList),
                indexno: app.getData('indexno'),
                account: app.getData('account'),
            }
            let { flag, msg } = await app.post(api.ReportsDuration, params)
            await this.setData({ submit_loading: false })
            if (flag === 1) {
                app.alert("修改成功", "success")
                onClose()
            } else {
                app.alert(msg, "error")
            }
        } else {
            this.props.onClose()
        }
    }

    /**
     * 打开记录列表
     */
    handleOpenRecord = async () => {
        this.state.record_modal = true
        await this.handleRecordData()
    }

    /**
     * 关闭记录列表
     */
    handleCloseRecord = () => {
        this.setData({ record_modal: false })
    }

    render () {
        let {
                data_loading, dataList, recordList, record_loading, selectedRowKeys, total, page, record_modal, multiple_duration, submit_loading,duration_sum,
                rpage, rtotal
            } = this.state,
            rowSelection = {
                selectedRowKeys,
                onChange: (selectedRowKeys) => this.setData({ selectedRowKeys })
            },
            columns = [
                {
                    title: '姓名',
                    dataIndex: 'vname',
                    key: 'vname',
                    width: '30%'
                },
                {
                    title: '存心编号',
                    dataIndex: 'bsrno',
                    key: 'bsrno',
                    width: '30%'
                },
                {
                    title: '服务时长',
                    dataIndex: 'duration',
                    key: 'duration',
                    width: '30%',
                    render: (duration, { indexno }) => {
                        return (
                            <span key={indexno}>
                                <InputNumber min={0.5} precision={1} step={0.5} defaultValue={parseFloat(duration)}
                                             onChange={(value) => this.handleSetEditList(indexno, value)}/>
                            </span>
                        )
                    }
                },
            ],
            columns2 = [
                {
                    title: '修改时间',
                    dataIndex: 'work_time',
                    key: 'work_time',
                    width: '25%'
                },
                {
                    title: '姓名',
                    dataIndex: 'vnames',
                    key: 'vnames',
                    width: '15%'
                },
                {
                    title: '存心编号',
                    dataIndex: 'bsrno',
                    key: 'bsrno',
                    width: '15%'
                },
                {
                    title: '修改前',
                    dataIndex: 'work_before',
                    key: 'work_before',
                    width: '15%',
                },
                {
                    title: '修改后',
                    dataIndex: 'work_after',
                    key: 'work_after',
                    width: '15%',
                },
                {
                    title: '修改人',
                    dataIndex: 'vname',
                    key: 'vname',
                    width: '15%',
                },
            ]
        return (
            <div style={{ height: '100%' }}>
                <div style={{ overflowY: 'auto', height: 'calc(100% - 90px)' }}>
                    <Table columns={columns}
                           locale={app.tbLocale(data_loading)}
                           loading={data_loading}
                           dataSource={dataList}
                           size="small"
                           scroll={{ y: "calc(100vh - 346px)" }}
                           width={800}
                           className="report-dration-table"
                           pagination={false}
                           rowSelection={rowSelection}
                           footer={() => {
                               return (
                                   <Row type="flex" justify="space-between" align="middle">
                                       <Col style={{display:'flex',alignItems:'center'}}>
                                           <Checkbox
                                               checked={dataList.length !== 0 && dataList.length === selectedRowKeys.length}
                                               onChange={this.handleAllSel}>全选</Checkbox>
                                           <InputNumber
                                               style={{ marginLeft: 20 }}
                                               min={0.5} precision={1} step={0.5}
                                               disabled={selectedRowKeys.length < 1}
                                               onChange={(value) => {
                                                   this.setData({ multiple_duration: value })
                                               }}/>
                                           <Button type="primary" style={{ marginLeft: 10 }}
                                                   disabled={selectedRowKeys.length < 1 && multiple_duration && multiple_duration >= 0.5}
                                                   onClick={() => this.handleMultipleSetEditList(multiple_duration, selectedRowKeys)}>确定</Button>
                                            <div style={{ marginLeft: 10}}>总服务时长：{duration_sum}</div>
                                       </Col>
                                       <Pagination total={total} size="small" pageSize={20} current={page}
                                                   showTotal={(total) => `总数量：${total}`}
                                                   onChange={this.handleDrationData}/>
                                   </Row>
                               )
                           }}
                    />
                </div>
                <div style={{color: 'red', marginTop: 12}}>
                    注：多选队员修改服务时长，先输入服务时长数，然后点击确定，最后点击保存。
                </div>
                <Row style={{ paddingTop: 24 }} type="flex" justify="space-between" align="middle">
                    <Col>
                        <Button type="primary" onClick={this.handleOpenRecord}>修改记录</Button>
                    </Col>
                    <Col>
                        <Button onClick={this.props.onClose}>取消</Button>
                        <Button type="primary" onClick={this.handleConfirm} style={{ marginLeft: 20 }}
                                loading={submit_loading}>保存</Button>
                    </Col>
                </Row>
                <Modal
                    visible={record_modal}
                    title="服务时长修改记录"
                    footer={null}
                    width={800}
                    zIndex={1002}
                    maskClosable={false}
                    destroyOnClose={true}
                    onCancel={this.handleCloseRecord}
                    bodyStyle={{ height: "calc(100vh - 100px)" }}
                    style={{ paddingBottom: 0, top: 20 }}
                >
                    <Table columns={columns2}
                           locale={app.tbLocale(record_loading)}
                           loading={record_loading}
                           dataSource={recordList}
                           size="small"
                           scroll={{ y: "calc(100vh - 224px)" }}
                           width={800}
                           className="report-dration-table"
                           pagination={{
                               total: rtotal,
                               pageSize: 20,
                               current: rpage,
                               showTotal: (total) => `总数量：${total}`,
                               onChange: this.handleRecordData
                           }}
                           footer={null}
                    />
                </Modal>
            </div>
        )
    }
}

ReportDration.propTypes = {
    id: PropTypes.any,
    onClose: PropTypes.func,
}

export default ReportDration



// WEBPACK FOOTER //
// ./src/routes/sign/ReportDration.jsx